

interface IAppInfo {
    baseApiURL: string
    // homeURL: string,
    importTKBFileUrl: string,
    // subSytemId: number,
    versionDataGridStorageKey?: string,
    headerHeight: number
}

const appInfo: IAppInfo = {
    baseApiURL: process.env.REACT_APP_API_BASE_URL?.toString() || "",
    // baseApiURL: "../../api",
    // homeURL: process.env.REACT_APP_PORTAL_URL?.toString() || "", 
    importTKBFileUrl: "https://docs.google.com/spreadsheets/d/1P6vUXyj3syPt0Sb0TnBxfRXnY1rvnaB1TT56V1-MaGo/edit?usp=sharing",
    // subSytemId: 11,
    versionDataGridStorageKey: "",
    headerHeight: 48
};


export { appInfo }

